<template>
  <DashboardHeaderContainer class="insights-header">
    <div class="actions-content">
      <div class="actions-content-left">
        <Legend
          class="actions-content-legend"
          height="12"
          width="12"
          :labels="legendLabels"
          :dotColors="dotColors"
        />
        <FilterRow
          :displayLimit="displayLimit"
          @add="$emit('add')"
          @complete="$emit('complete')"
        ></FilterRow>
      </div>
      <DashboardCalendarPicker
        id="insights-header-calendar"
        :value="localDateValue"
        :minDate="minDate"
        :maxDate="maxDate"
        @click="$emit('dateApply', $event)"
      ></DashboardCalendarPicker>
    </div>
  </DashboardHeaderContainer>
</template>
<script>
import { mapState } from 'vuex';
import DashboardCalendarPicker from '../Common/DashboardCalendarPicker.vue';
import DashboardHeaderContainer from '../Common/DashboardHeaderContainer.vue';
import FilterRow from '../Common/FilterRow.vue';
import Legend from '../../common/Legend.vue';

export default {
  props: {
    dateValue: {
      type: Object,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
    displayLimit: {
      type: Number,
      default: 2,
      validator: val => val > 0 && val <= 3,
    },
  },
  components: {
    DashboardCalendarPicker,
    DashboardHeaderContainer,
    FilterRow,
    Legend,
  },
  data() {
    return {
      localDateValue: this.dateValue,
    };
  },
  computed: {
    ...mapState({
      activeView: state => state.main.activeView,
    }),
    legendLabels() {
      const isSalesInsightsView = this.activeView === 'Sales Insights';
      const primaryLabel = isSalesInsightsView
        ? 'Percent of Units Sold'
        : 'Purchase Intent Rate';
      const secondaryLabel = isSalesInsightsView
        ? 'Attributable Sales'
        : 'Measurable Views';

      return [
        { name: 'primary', value: primaryLabel },
        { name: 'secondary', value: secondaryLabel },
      ];
    },
    dotColors() {
      return {
        primary: '#00A6A4',
        secondary: '#4369F4',
      };
    },
  },
  watch: {
    dateValue() {
      this.localDateValue = this.dateValue;
    },
  },
};
</script>
<style scoped>
.insights-header {
  display: flex;
  justify-content: center;
}

.actions-content {
  height: 100%;
  width: 1360px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions-content-left {
  display: flex;
  align-items: center;
}

.actions-content-legend {
  padding-left: 8px;
}

.actions-content-legend >>> .text {
  color: #223448;
  font-weight: 400;
  text-transform: none;
}

.report-field-row {
  padding-left: 18px;
}

#insights-header-calendar {
  width: 300px;
  height: 65%;
  padding-right: 24px;
}
</style>
<style>
.insights-header #insights-header-calendar .picker-container.dropdown {
  right: 5px;
  z-index: 2;
}

.insights-header #insights-header-calendar .date-range-control-wrapper {
  background: transparent;
}

.insights-header #insights-header-calendar .date-range-control {
  background: #FFFFFF;
  cursor: pointer;
}

.insights-header #insights-header-calendar .help-text {
  background: transparent;
  padding: 0 12px;
  z-index: 2;
}
</style>
